var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1923 8.90487C15.4066 8.69065 15.6973 8.57031 16.0003 8.57031C16.3033 8.57031 16.594 8.69065 16.8083 8.90487L21.9513 14.0479C22.1573 14.2638 22.2707 14.5518 22.2672 14.8503C22.2637 15.1488 22.1436 15.434 21.9325 15.6451C21.7215 15.8562 21.4362 15.9763 21.1377 15.9798C20.8393 15.9833 20.5513 15.8699 20.3353 15.6639L17.1433 12.4719V22.2849C17.1433 22.588 17.0229 22.8787 16.8085 23.0931C16.5942 23.3074 16.3034 23.4279 16.0003 23.4279C15.6972 23.4279 15.4064 23.3074 15.1921 23.0931C14.9777 22.8787 14.8573 22.588 14.8573 22.2849V12.4719L11.6653 15.6639C11.5601 15.7741 11.434 15.8622 11.2943 15.923C11.1545 15.9838 11.0041 16.016 10.8517 16.0178C10.6994 16.0196 10.5482 15.9909 10.4071 15.9334C10.266 15.8759 10.1378 15.7908 10.0301 15.6831C9.92235 15.5753 9.83724 15.4472 9.77977 15.3061C9.72229 15.1649 9.6936 15.0138 9.69539 14.8614C9.69718 14.7091 9.72941 14.5586 9.79019 14.4189C9.85097 14.2792 9.93906 14.153 10.0493 14.0479L15.1923 8.90487Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpWhite);
export default __webpack_public_path__ + "static/media/arrow-up-white.efec99672536c0705fa37a357826de36.svg";
export { ForwardRef as ReactComponent };